import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'react-toolbox/lib/dialog';
import {
  removeSelectedModules,
  showRemoveModulesConfirmationDialog,
} from 'browse-media/redux/browseMediaActions';
import styles from 'browse-media/components/RemoveModulesConfirmationDialog.css';

const RemoveModulesConfirmationDialog = ({
  active,
  onCancel,
  onRemove,
  selectedModuleIds,
}) =>
  <Dialog
    theme={styles}
    active={active}
    title="Are you sure?"
    onEscKeyDown={onCancel}
    onOverlayClick={onCancel}
    actions={[
      { label: 'Cancel', onClick: onCancel },
      { label: 'Remove', onClick: onRemove },
    ]}
  >
    {selectedModuleIds.length === 1
      ? <p>Remove the selected module?</p>
      : <p>
          Remove all {selectedModuleIds.length} selected modules?
        </p>}
  </Dialog>;

const mapStateToProps = state => {
  const {
    confirmationDialogActive,
    selectedModuleIds,
  } = state.browseMedia.removeModulesDrawer;
  return {
    active: confirmationDialogActive,
    selectedModuleIds,
  };
};

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(showRemoveModulesConfirmationDialog(false)),
  onRemove: () => dispatch(removeSelectedModules()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  RemoveModulesConfirmationDialog,
);
